import { observer } from 'mobx-react-lite'

import { EntityHeader, HeaderChip } from '@/Ship/Components/EntityCard'
import { formatPhone } from '@/Ship/Helpers/formatPhone'

export interface CrmContactFormContextLike {
    isEditable?: boolean
    values?: {
        uuid?: unknown
        '@id'?: unknown
        title?: unknown
        name?: unknown
        lastName?: unknown
        email?: unknown
        phone?: unknown
        _permissions?: { update?: boolean; comment?: boolean }
        [key: string]: unknown
    }
}

const text = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

/**
 * Шапка картки контакту (`SPEC-009` §8.5) — окремим observer-компонентом: вона
 * читає ім'я й контакти, які редагують, а шаблон картки цього робити не може
 * (`SPEC-002` §4.2).
 *
 * Назва — «Прізвище Ім'я», як `title` запису; поки ім'я правлять, шапка
 * складає його з полів, а не чекає збереження. Праворуч — телефон і пошта:
 * клік копіює, **без іконки** (правило дизайну карток CRM).
 */
export const CrmContactCardHeader = observer(({ formContext }: { formContext: CrmContactFormContextLike }) => {
    const values = formContext.values ?? {}
    const title = [text(values.lastName), text(values.name)].filter(Boolean).join(' ') || text(values.title)
    const phone = text(values.phone)
    const email = text(values.email)

    const contacts =
        phone || email ? (
            <>
                {phone ? <HeaderChip copyText={formatPhone(phone)}>{formatPhone(phone)}</HeaderChip> : null}
                {email ? <HeaderChip copyText={email}>{email}</HeaderChip> : null}
            </>
        ) : undefined

    return <EntityHeader aside={contacts} {...(title !== '' ? { title } : {})} />
})
